module.exports = __webpack_public_path__ + "img/result2.fa2e7cd5.png";